var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgChristadelphianIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16 20C13.8783 20 11.8434 19.1571 10.3431 17.6569C8.84286 16.1566 8 14.1217 8 12C8 9.87827 8.84286 7.84344 10.3431 6.34315C11.8434 4.84286 13.8783 4 16 4C18.1217 4 20.1566 4.84286 21.6569 6.34315C23.1571 7.84344 24 9.87827 24 12C24 14.1217 23.1571 16.1566 21.6569 17.6569C20.1566 19.1571 18.1217 20 16 20ZM16 20L20.5333 27.8533L22.664 23.5427L27.4613 23.852L22.928 16M9.06931 16L4.53597 23.8533L9.33331 23.5427L11.464 27.852L15.9973 20",
    stroke: "#172B4D",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChristadelphianIcon);
export default __webpack_public_path__ + "static/media/christadelphian-icon.ce27642f0145abfb633b1aab78043472.svg";
export { ForwardRef as ReactComponent };